import ChipIcon from '../ChipIcon';

const FigureRow = ({
    t,
    figure,
}) => (
    <div className="overview-esg-rating__figure-row">
        <span className="overview-esg-rating__figure-label">
            <ChipIcon />
            {t(figure.label)}
        </span>
        <span className="overview-esg-rating__figure-value">
            {figure.value}
        </span>
    </div>
);

const OtherKeyFigures = ({
    t,
    figures,
}) => {
    const rows = figures || [];
    const half = Math.ceil(rows.length / 2);
    const columns = [rows.slice(0, half), rows.slice(half)];

    return (
        <>
            <p className="overview-esg-rating__eyebrow mb-2">
                {t('Other Key Figures')}
            </p>
            <div className="overview-esg-rating__figures">
                {columns.map((column, index) => (
                    <div
                        key={column[0]?.key || `esg-figures-column-${index}`}
                        className="overview-esg-rating__figures-column"
                    >
                        {column.map((figure) => (
                            <FigureRow
                                key={figure.key}
                                t={t}
                                figure={figure}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
};

export default OtherKeyFigures;
